import { Id } from 'src/types'

export enum PartnersActionTypes {
  GET_PARTNERS = '@partners/GET_PARTNERS',
  GET_PARTNERS_FAILURE = '@partners/GET_PARTNERS_FAILURE',
  GET_PARTNERS_SUCCESS = '@partners/GET_PARTNERS_SUCCESS',
  SEND_PARTNER = '@partners/SEND_PARTNER',
  SEND_PARTNER_FAILURE = '@partners/SEND_PARTNER_FAILURE',
  SEND_PARTNER_SUCCESS = '@partners/SEND_PARTNER_SUCCESS',
  SET_TICKETS_EMISSION = '@partners/SET_TICKETS_EMISSION'
}

export type ResponseDataRequests = {
  partners: ResponseDataRequestsItem[]
}

export interface ResponseDataRequestsItem {
  active: Boolean
  additional_info: string
  address_number: string
  address: string
  agency_partner: []
  city_id: Id
  city_name: string
  latitude: string
  longitude: string
  partner_description: string
  partner_hotels: []
  partner_id: Id
  partner_name: string
  partner_number: Number
  partner_type: string
  partner_vat_number: string
  quarter: string
  state_id: Id
  state_name: string
  zip_code: string
}

export type ResponseDataRequestTotals = {
  request_totals: {
    total_emissions: number
    total_quotations: number
  }
}

export type PartnersState = ResponseDataRequestTotals & {
  readonly error: string
  readonly list: ResponseDataRequestsItem[]
  readonly loading: boolean
  readonly response: any
  readonly sendPartnerError: string
  readonly sendPartnerLoading: boolean
  readonly total_results: number
}
